import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private partnerDomainValue: string;

  public get partnerDomain(){
    return this.partnerDomainValue;
  }

  constructor() {
    if(window.location.host.endsWith('dev.drklein-plattform.de')){
      this.partnerDomainValue =  'https://partner.dev.drklein-plattform.de';
    } else if(window.location.host.endsWith('staging.drklein-plattform.de')){
      this.partnerDomainValue =  'https://partner.staging.drklein-plattform.de';
    } else if(window.location.host.endsWith('drklein-plattform.de')) {
      this.partnerDomainValue =  'https://partner.drklein-plattform.de';
    } else {
      this.partnerDomainValue =  'https://partner.dev.drklein-plattform.de';
    }
  }
}
